<app-generic-field [label]="label" [hideLabel]="hideLabel">
  <p-dropdown [(ngModel)]="value" [options]="options" [optionLabel]="optionLabel" (ngModelChange)="valueChange.emit($event)"></p-dropdown>
</app-generic-field>
